"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decideRecoveryMethod = exports.getUsernameType = void 0;

var _enums = require("../enums");

var _errors = require("../errors");

var _validators = require("../validators");

const getUsernameType = async username => {
  try {
    await (0, _validators.validateEmail)(username);
    return _enums.USERNAME_TYPES.email;
  } catch (emailError) {
    try {
      await (0, _validators.validateDocument)(username);
      return _enums.USERNAME_TYPES.cpf;
    } catch (documentError) {
      throw new _errors.UnexpectedArgumentError('The argument not match with an email or document');
    }
  }
};

exports.getUsernameType = getUsernameType;

const decideRecoveryMethod = (hasEmail, hasCellphone) => {
  if (hasEmail) return _enums.RECOVERY_METHODS.email;
  if (hasCellphone) return _enums.RECOVERY_METHODS.cellphone;
  throw new _errors.RecoveryMethodError('Account without recovery method');
};

exports.decideRecoveryMethod = decideRecoveryMethod;